import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-file-download-button',
  standalone: true,
  imports: [],
  templateUrl: './file-download-button.component.html',
  styleUrl: './file-download-button.component.scss',
})
export class FileDownloadButtonComponent implements OnInit {
  @Input() fileUrl!: string;
  @Input() buttonName: string = 'Download';

  isDisabled: boolean = false;

  constructor() {}

  ngOnInit(): void {
    if (!this.fileUrl || !this.fileUrl.length) {
      this.isDisabled = true;

      // console.error('File URL is required for file download button');
    }
  }

  downloadFile() {
    if (this.isDisabled) {
      return;
    }

    window.open(this.fileUrl, '_blank');
  }
}
